import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Dashboard as DashboardIcon } from '@mui/icons-material';

import { MenuItem } from 'types/global';

type DashboardProps = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function Dashboard({ selected, onSelect, open }: DashboardProps) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/dashboard"
			selected={selected === MenuItem.Dashboard}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.Dashboard)}
		>
			<ListItemIcon>
				<DashboardIcon />
			</ListItemIcon>
			{open && <ListItemText primary={t('common:dashboard')} />}
		</ListItem>
	);
}
